import { useContext, useMemo } from 'react'
import ThemeContext from './context/themeContext'
export default function useTheme() {
    const { dark } = useContext(ThemeContext);
    return useMemo(() => {
        return {dark};
    }, [dark]);
}
